import { Box, Button, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import trashGif from '../../assets/images/icons/trash.gif'
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        width: '450px',
        maxWidth: '1000px !important',
        height: '250px',
        padding: '24px',
        BorderRadius: '16px', scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));
const DeleteModal = (props) => {
    const { open, setOpen, handleDelete, title, subHeading } = props;
    const handleClose = () => setOpen(false);
    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}>
            <Stack direction="column" gap={3} justifyContent="center" alignItems="center">
                <img src={trashGif} alt="trashGif" style={{ height: '40px', width: '40px' }} />
                <Box sx={{ textAlign: 'center' }}>
                    <Typography sx={{ fontWeight: '700', fontSize: '16px', color: 'var(--red)', textTransform: 'capitalize' }}>{title}</Typography>
                    <Typography sx={{ fontWeight: '400', fontSize: '14px', color: '#433E3F', marginTop: '10px', textTransform: 'capitalize' }}>{subHeading}</Typography>
                </Box>
                <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
                    <Button sx={{ "&:hover": { background: '#B5B3B3', color: 'white', border: '0px' }, padding: '12px 10px', width: '164px', height: '43px', borderRadius: '6px', fontSize: '14px', fontWeight: '400', color: 'white', background: '#B5B3B3' }} onClick={handleClose}>Cancel</Button>
                    <Button sx={{ "&:hover": { background: 'var(--red)', color: 'white', border: '0px' }, padding: '12px 10px', width: '164px', height: '43px', borderRadius: '6px', fontSize: '14px', fontWeight: '400', color: 'white', background: 'var(--red)' }} onClick={handleDelete}>Delete</Button>
                </Stack>
            </Stack>
        </BootstrapDialog>
    )
}

export default DeleteModal